interface SubMenuItem {
  title: string;
  path: string;
  isComingSoon?: boolean;
}

interface MenuItem {
  title: string;
  path?: string;
  items?: SubMenuItem[];
}

export const MENU_ITEMS: MenuItem[] = [
  {
    title: 'Trading',
    items: [
      { title: 'Secondaries', path: '/trading/otc' },
      // { title: 'Perps', path: '/trading/perps', isComingSoon: true },
    ],
  },
  // {
  //   title: 'Yield',
  //   items: [
  //     { title: 'Early TVL', path: '/yield/early-tvl' },
  //     { title: 'Structured Products', path: '/yield/structured-products', isComingSoon: true },
  //     { title: 'DeFi Yield Vaults', path: '/yield/defi-vaults', isComingSoon: true },
  //   ],
  // },
  {
    title: 'Data Room',
    items: [
      { title: 'Funding Rounds', path: '/data-room/funding-rounds' },
      // { title: 'Unlocks', path: '/data-room/unlocks' },
    ],
  },
  {
    title: 'Portfolio',
    items: [
      { title: 'Portfolio Tracker', path: '/portfolio' },
      { title: 'Create Portfolio', path: '/portfolio/create' },
    ],
  },
  // {
  //   title: 'RWA',
  //   items: [
  //     { title: 'SME', path: '/rwa/sme', isComingSoon: true },
  //     { title: 'Minerals', path: '/rwa/minerals', isComingSoon: true },
  //     { title: 'Hashrate', path: '/rwa/hashrate', isComingSoon: true },
  //   ],
  // },
  // {
  //   title: 'Partnerships',
  //   items: [
  //     { title: 'Partnership Benefits', path: '/partnerships/benefits' },
  //     { title: 'Partner Portal', path: '/partnerships/portal' },
  //     { title: 'Partner Referrals', path: '/partnerships/referrals' },
  //     { title: 'APIs - Docs & Demo', path: '/partnerships/api' },
  //   ],
  // },
  {
    title: 'Organizations',
    path: '/organizations',
  },
  {
    title: 'Contact Us',
    path: '/contact',
  },
]; 